<nav>
  <ul class="mainHeader__mainNav" role="menubar">
    <ng-container *ngFor="let level2 of mainNav; let ii = index">
      <li
        #ref
        (mouseover)="mouseoverUnderline(ii)"
        (mouseout)="mouseoutUnderline()"
        class="mainNav__level2"
        role="menuitem"
        [attr.aria-haspopup]="level2.children && level2.children.length > 0 ? true : null"
        [ngClass]="{active: level2.active, 'd-none': level2.mnemonic === 'direct-shipping' && !directShippingEligible}"
      >
        <!-- LVL2 URL -->
        <ng-container *ngIf="level2.url === '#'; else titleWithUrl">
          <span
            (mouseover)="mouseoverlevel1Title(ii)"
            (mouseout)="clearTimeoutLevel2()"
            (click)="onClickLevel2Link(ii, level2.active, $event, false)"
            class="mainNav__level2__title mainNav__level2__title--notLink"
            [ngClass]="{
              active: level2.active,
              'mainNav__title__arrows-xs': level2.children && level2.children.length > 0
            }"
          >
            <span class="underlineActive-xs">{{ level2.label }}</span>
          </span>
        </ng-container>

        <!-- TITLE URL -->
        <ng-template #titleWithUrl>
          <vc-ref
            [resource]="level2.url"
            [anchor]="!level2.anchor"
            (mouseover)="mouseoverlevel1Title(ii)"
            (mouseout)="clearTimeoutLevel2()"
            (click)="onClickLevel2Link(ii, level2.active, $event)"
            class="mainNav__level2__title"
            [ngClass]="{
              active: level2.active,
              'mainNav__title__arrows-xs': level2.children && level2.children.length > 0,
              'mainNav__level2__title--event': eventMnemonics.includes(level2.mnemonic)
            }"
          >
            <span class="underlineActive-xs">{{ level2.label }}</span>
          </vc-ref>
        </ng-template>

        <ul
          *ngIf="level2.children && level2.children.length > 0"
          class="mainNav__level2__content"
          role="menu"
          [ngClass]="{active: level2.active}"
          (mouseleave)="hideLevel2_onDesktop(ii)"
        >
          <li
            *ngFor="let level3 of level2.children; let iii = index"
            class="mainNav__level3"
            [ngClass]="{'mainNav__level3--brands': level2.mnemonic == 'designers'}"
            role="menuitem"
            (click)="resetCatalogPage()"
          >
            <vc-ref
              [resource]="deviceIsLgUp ? level3.url : ''"
              [anchor]="!level3.anchor"
              class="mainNav__level3__title"
              [ngClass]="{
                'mainNav__title__arrows-xs': level3.children.length > 0
              }"
              (click)="onClickLevel3Link(ii, iii, level3.active, level3.children && level3.children.length > 0, $event)"
            >
              <span class="underlineActive-xs">{{ level3.label }}</span>
            </vc-ref>

            <ul
              *ngIf="level3.children"
              class="mainNav__level3__content"
              [ngClass]="{active: level3.active}"
              role="menu"
            >
              <li *ngFor="let level4 of level3.children; let iiii = index" role="menuitem">
                <vc-ref
                  [isBlock]="true"
                  [resource]="level4.url"
                  [anchor]="!level4.anchor"
                  class="mainNav__level4__title"
                  [ngClass]="{
                    'mainNav__level4__title--comingSoon': level4.id == '1006',
                    'mainNav__level4__title--allBrands': level4.id == '1057'
                  }"
                  [attr.data-tag]="level4.id == '1006' ? 'Premium' : ''"
                  (click)="closeMenu()"
                >
                  {{ level4.label }}
                </vc-ref>
              </li>
            </ul>
          </li>

          <li *ngIf="level2.editorPick" class="mainNav__level3 mainNav__level3--editorsPicks" role="menuitem">
            <vc-ref [isBlock]="true" [resource]="level2.editorPick.url" class="mainNav__level3__title">
              {{ level2.editorPick.label }}
            </vc-ref>
            <img
              *ngIf="level2.editorPick.picture.path !== '#'"
              class="editorsPicks__image"
              src="{{ level2.editorPick.picture }}"
              alt="{{ level2.editorPick.legend }}"
            />
            <p class="mainNav__level4__title">{{ level2.editorPick.legend }}</p>
          </li>
        </ul>
      </li>
    </ng-container>
    <span vcUnderline> </span>
  </ul>
</nav>
